export enum TicketAssignStatus {
    all = 0,
    unassigned = 1,
    assigned = 2,
}
